<template>
  <div class="addsite">
    <GlobTopNav title="添加地址"></GlobTopNav>

    <div class="van-content">
      <van-cell-group>
        <van-field :required="true" v-model="name" placeholder="请输入收件人名称" label="收货人" />
        <van-field
          type="tel"
          :required="true"
          v-model="mobile"
          placeholder="请输入联系方式"
          label="手机号码"
        />
        <!-- <van-field
          v-model="postcode"
          placeholder="请输入邮政编码"
          label="邮政编码"
        /> -->
        <van-field
          v-model="sitedDatasName"
          placeholder="选择地址"
          readonly
          label="省市区"
          @click="cityPickerShow"
        />
        <van-field
          :required="true"
          type="textarea"
          class="specific"
          v-model="setess"
          placeholder
          label="详细地址"
        />
        <van-cell title="设为默认地址">
          <van-switch v-model="checked" size="24" active-color="rgba(227, 51, 49, 1)" />
        </van-cell>
      </van-cell-group>

      <div class="btn">
        <van-button size="large" class="addSiteBtn theme-bd theme-bg radius6" @click="sendDatas">
          保存地址
        </van-button>
      </div>
    </div>
    <!--地址选择弹框-->
    <!-- <city-picker ref="cityPicker" @confirm="confirm"></city-picker> -->
    <city-picker ref="cityPicker" @listenSitedata="geSitedatas"></city-picker>
  </div>
</template>

<script>
import CityPicker from '@/pages/user/mysite/cityPicker'
import TopNav from '../../../components/topnav'
export default {
  name: 'addsite',
  components: {
    CityPicker,
    TopNav
  },
  data() {
    return {
      sitedDatas: '',
      sitedDatasName: '',
      checked: true, //设为默认
      name: '', //收货人
      mobile: '', //手机号
      site: '', //省市区
      setess: '', //详细地址
      postcode: '', //邮编
      province: '',
      city: '',
      town: '',
      county: '',
      provincename: '',
      cityname: '',
      townname: '',
      countyname: '',
      len: 0,
      btn: false
    }
  },
  methods: {
    onClickRight() {
      this.$refs.TopNav.topnavPlay()
    },
    cityPickerShow() {
      this.$refs.cityPicker.setSiteShow(true)
    },
    // confirm(data) {
    //   var area = "";
    //   // this.site=''
    //   this.siteid = [];
    //   this.sitename = [];
    //   data.forEach((item) => {
    //     if (item) {
    //       area += item.name + "-";
    //       this.siteid.push(item.id);
    //       this.sitename.push(item.name);
    //     }
    //   });

    //   this.provincename = this.sitename[0];
    //   this.cityname = this.sitename[1];
    //   this.townname = this.sitename[2];
    //   this.countyname = this.sitename[3] ? this.sitename[3] : "";

    //   this.province = this.siteid[0];
    //   this.city = this.siteid[1];
    //   this.town = this.siteid[2];
    //   this.county = this.siteid[3] ? this.siteid[3] : 0;
    //   area = area.substr(0, area.length - 1); //地址
    //   this.$refs.cityPicker.setSiteShow(false);
    //   this.sitedDatasName = area;
    // },
    geSitedatas(datas) {
      this.sitedDatasName = ''
      this.sitedDatas = datas
      if (datas[0].id != undefined) {
        this.sitedDatasName += datas[0].name
        this.province = datas[0].id
        this.provincename = datas[0].name
      }
      if (datas[1].id != undefined) {
        this.sitedDatasName += ' ' + datas[1].name
        this.city = datas[1].id
        this.cityname = datas[1].name
      }
      if (datas[2].id != undefined) {
        this.sitedDatasName += ' ' + datas[2].name
        this.county = datas[2].id
        this.countyname = datas[2].name
      }
      if (datas[3].id != undefined) {
        this.sitedDatasName += ' ' + datas[3].name
        this.town = datas[3].id
        this.townname = datas[3].name
      } else {
        this.town = 0
        this.townname = ''
      }
    },
    goBack: function () {
      history.back(-1)
    },
    sendDatas: function () {
      var isUser = localStorage.getItem('BLHuser')
      var mallid = localStorage.getItem('mallid')
      var moren = 0
      if (this.checked == true) {
        moren = 1
      } else {
        moren = 0
      }
      this.len = 0
      this.getByteLen(this.name)
      var reg = /^[1][3456789][0-9]{9}$/
      if (this.btn == false) {
        this.btn = true
        //判断收货人
        if (this.name == '') {
          this.btn = false
          this.$toast('请输入收货人')
          return
        }
        //判断收货人姓名长度
        if (this.len > 24) {
          this.btn = false
          this.$toast('收货人姓名必须小于24个字符！')
          return
        }
        //判断手机号
        if (!reg.test(this.mobile)) {
          this.btn = false
          this.$toast('请输入正确的手机号！')
          return
        }
        //判断地址
        if (this.provincename == '') {
          this.btn = false
          this.$toast('请填写完整地址')
          return false
        }
        if (this.countyname == '请选择') {
          this.$toast('请填写完整地址')
          return false
        }
        if (this.len < 24 && this.len > 0) {
          this.$api.post(
            'user/address/add',
            {
              id_example: mallid,
              token_user: isUser,
              default: moren,
              name: this.name,
              phone: this.mobile,
              address: this.setess,
              zip: this.postcode,
              province: this.province,
              city: this.city,
              town: this.town,
              county: this.county,
              province_str: this.provincename,
              city_str: this.cityname,
              town_str: this.townname,
              county_str: this.countyname
            },
            res => {
              if (res.data.code == '100') {
                this.goBack()
                this.btn = false
              } else {
                this.$toast(res.data.message)
                this.btn = false
              }
            }
          )
        } else {
          this.btn = false
          this.$toast('收货人姓名必须小于24个字符！')
        }
      }
    },
    getByteLen: function (val) {
      //限制24个字符
      var _this = this
      for (var i = 0; i < val.length; i++) {
        var a = val.charAt(i)
        if (a.match(/[^\x00-\xff]/gi) != null) {
          _this.len += 2
        } else {
          _this.len += 1
        }
      }
      return _this.len
    }
  },
  mounted() {}
}
</script>

<style lang="less">
.addsite {
  width: 100%;
  background: #f5f5f5;
  min-height: 100vh;
  .specific {
    height: 1.2rem;
    .van-field__value {
      height: 0.48rem !important;

      .van-field__body {
        .van-field__control {
          min-height: 100% !important;
        }
      }
    }
  }
  .van-cell {
    padding: 0.3rem 0.36rem;

    .van-cell__title {
      font-size: .28rem;
      font-weight: bold;
      color: rgba(38, 38, 38, 0.8);
      line-height: .48rem;
    }
  }
  .van-cell--required::before {
    content: '*';
    left: 0.2rem;
    font-size: 0.28rem;
    color: #f44;
    top: 0.26rem;
  }
  .van-radio {
    height: 0.22rem;
  }

  .van-cell-group {
    background-color: #fff;
  }

  .btn {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    .addSiteBtn {
      width: 6.3rem;
      height: 0.96rem;
      background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
      border-radius: 0.48rem;
      font-size: 0.3rem;
      font-weight: 500;
      color: #ffffff;
      line-height: 0.42rem;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/mysite/addsite.vue